import { SvgIcon, SvgIconProps } from "@mui/material";
import { forwardRef } from "react";

interface CheckCircleIconProps extends SvgIconProps {
  width?: string | number;
  height?: string | number;
}

export const CheckCircleIconCustomSize = forwardRef<
  SVGSVGElement,
  CheckCircleIconProps
>(({ width = "22px", height = "22px", ...props }, ref) => {
  // Convert numeric values to pixel strings if needed
  const formattedWidth = typeof width === "number" ? `${width}px` : width;
  const formattedHeight = typeof height === "number" ? `${height}px` : height;

  return (
    <SvgIcon
      {...props}
      ref={ref}
      sx={{
        width: formattedWidth,
        height: formattedHeight,
        ...props.sx, // Merge with any other sx props passed
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%" // Make SVG fill the SvgIcon container
        height="100%" // Make SVG fill the SvgIcon container
        fill="none"
        viewBox="0 0 22 22" // Keep original aspect ratio
        preserveAspectRatio="xMidYMid meet" // Maintain aspect ratio
      >
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M20 11a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM7.47 9.97a.75.75 0 0 1 1.06 0l1.72 1.72 3.22-3.22a.75.75 0 1 1 1.06 1.06l-3.749 3.75a.75.75 0 0 1-1.061 0l-2.25-2.25a.75.75 0 0 1 0-1.06Z"
          clipRule="evenodd"
        />
      </svg>
    </SvgIcon>
  );
});

// Set display name for better debugging
CheckCircleIconCustomSize.displayName = "CheckCircleIconCustomSize";
